
define('text!modules/reporting/campaigns/templates/report_info.html',[],function () { return '<div class="report-info unselectable">\n  <strand-icon type="info" width="14" height="14" title="Last Updated: <span>{{ lastModified }}</span>"></strand-icon>\n</div>\n';});

